import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { withi18n } from "../../../customer/components";
import RowsTemplate from "../content/templates/RowsTemplate";
import PortalButton from "../buttons/portal-button/PortalButton";
import Checkbox from "../form-elements/check-box/Checkbox";
import { useAppConfig } from "@limitless/common/hooks";
import { ThemeProvider } from "@emotion/react";
import useCustomTheme from "expert-web-app/src/utils/hooks/useCustomTheme";
const templateMapping = {
  basic: 1,
  twoRows: 2
};
const AnnouncementContent = ({
  announcement,
  onDismiss,
  classes,
  t,
  onSave,
  remoteContentComponent,
  isCrowdManager = false,
  title,
  date
}) => {
  const getAcknowledged = React.useCallback(() => {
    return announcement.acknowledge && !announcement.acknowledged ? false : true;
  }, [announcement.acknowledge, announcement.acknowledged, announcement.announcementId]);
  const hasAcknowledged = getAcknowledged();
  const [acknowledged, setAcknowledged] = React.useState(hasAcknowledged);
  const [loading, setLoading] = React.useState(false);
  const {
    getContactUsUrl
  } = useAppConfig();
  const history = useHistory();
  React.useEffect(() => {
    setAcknowledged(getAcknowledged());
  }, [announcement.announcementId, getAcknowledged]);
  const {
    template,
    acknowledge
  } = announcement;
  const handleDismiss = () => {
    setLoading(true);
    onDismiss(announcement, () => {
      setLoading(false);
    });
  };
  const handleContactUsClick = () => {
    if (onSave) {
      onSave();
    }
    if (!isCrowdManager) {
      const naivgationUrl = "/contactusscreen";
      const url = getContactUsUrl(naivgationUrl);
      if (url === naivgationUrl) {
        history.push({
          pathname: url,
          state: announcement
        });
      } else {
        window.open(url, "_blank");
      }
    }
  };
  const renderRow = (index, component) => {
    const RemoteContent = remoteContentComponent;
    return /*#__PURE__*/React.createElement(RemoteContent, {
      content: component.value,
      wrapWhiteSpace: false,
      allowNewWindow: true
    });
  };
  const theme = useCustomTheme();
  const renderButtons = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.dismissContainer
    }, (template === null || template === void 0 ? void 0 : template.addContactUsAction) && /*#__PURE__*/React.createElement(PortalButton, {
      variant: "outlined",
      className: classes.buttonPadding,
      onClick: handleContactUsClick,
      id: "contactUsAnnouncementButton",
      disabled: !acknowledged,
      style: {
        borderColor: theme.palette.primary.main
      }
    }, t("Contact Us")), (typeof onSave === "undefined" && (template === null || template === void 0 ? void 0 : template.addContactUsAction) || !(template !== null && template !== void 0 && template.addContactUsAction)) && /*#__PURE__*/React.createElement(PortalButton, {
      variant: "outlined",
      className: classes.buttonPadding,
      onClick: handleDismiss,
      disabled: !acknowledged,
      id: "dismissAnnouncementButton",
      loading: loading,
      style: {
        borderColor: theme.palette.primary.main
      }
    }, t("Delete")), onSave && /*#__PURE__*/React.createElement(PortalButton, {
      variant: "contained",
      onClick: onSave,
      disabled: !acknowledged,
      id: "readLaterButton"
    }, t("Save")));
  };
  let Template = null;
  let numOfRows = 0;
  if (template) {
    Template = RowsTemplate;
    numOfRows = templateMapping[template.name];
    //just incase we get an unrecognised template name
    numOfRows = numOfRows ? numOfRows : 1;
  }
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.announcementContentContainer,
    style: {
      backgroundColor: theme.palette.background.elevation1
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textPrimary"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, date)), /*#__PURE__*/React.createElement("div", {
    className: classes.contentContainer,
    id: "announcementContent",
    style: {
      fontFamily: theme.typography.body2.fontFamily,
      fontSize: theme.typography.body2.fontSize
    }
  }, Template ? /*#__PURE__*/React.createElement(Template, {
    components: template.component,
    numberOfRows: numOfRows,
    renderRow: renderRow
  }) : /*#__PURE__*/React.createElement(Typography, null, t("Announcement template not supported")), acknowledge && /*#__PURE__*/React.createElement("div", {
    className: classes.requiresAckContainer
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: "acknowledged",
    value: "acknowledged",
    checked: acknowledged,
    label: /*#__PURE__*/React.createElement(Typography, {
      variant: "body2",
      color: "textPrimary"
    }, t("I acknowledge that I have read this announcement and agree to its terms")),
    id: "acknowledgedCheckBox",
    disabled: hasAcknowledged,
    onChange: () => setAcknowledged(!acknowledged),
    capitalize: false,
    checkboxLabelRoot: classes.checkboxLabel,
    style: {
      paddingLeft: "0px"
    }
  }), renderButtons()), !acknowledge && renderButtons())));
};
const styles = theme => {
  return {
    checkboxLabel: {
      width: "100%"
    },
    headerContainer: {
      display: "flex",
      justifyContent: "space-between",
      padding: "0px 24px"
    },
    announcementContentContainer: {
      marginTop: 60,
      marginLeft: 60,
      marginRight: 60,
      marginBottom: 60,
      display: "flex",
      flexDirection: "column",
      justifyContent: "left",
      padding: 20,
      borderRadius: 24
    },
    contentContainer: {
      backgroundColor: "transparent",
      padding: "0px 24px"
    },
    requiresAckContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "left"
    },
    dismissContainer: {
      display: "flex",
      justifyContent: "flex-start",
      margin: "20px 0px",
      position: "relative",
      width: "100%"
    },
    buttonPadding: {
      marginRight: 16
    }
  };
};
export default withStyles(styles)(withi18n(AnnouncementContent));
AnnouncementContent.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  announcement: PropTypes.object.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  remoteContentComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.object]).isRequired,
  isCrowdManager: PropTypes.bool,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired
};